export default __webpack_public_path__ + "static/media/speakers-desktop-banner.cda73f9e.svg";